export enum ViewModule {
  companyFeature = 'companyFeature',
  companyMarketplace = 'companyMarketplace',
  accountantMarketPlace = 'accountantMarketPlace',
}

export type IdsRequest = {
  ids: string[];
};
